export default "__VITE_ASSET__6d1dae1b__"